// import { Routes, Route, Link } from 'react-router-dom';
import { strToolNameHeadline, default_tooltip_show, default_tooltip_hide } from '../Consts';
import React from 'react';

import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { openNewTabWithChecklist } from '../Functions';

import CSSToggler from '../CSSToggler/CSSToggler.jsx';


import './NavbarTop.css';

// export function NavbarTop() {
const NavbarTop = ({ parentState, backCallerHandleToggleOffCanvas, backCallerHandlePrint, backCallerGoModal }) => {

    const { klassenarbeiten } = parentState;
    const hasKlassenarbeiten = klassenarbeiten && klassenarbeiten.length > 0;
    const hasMaxPunkte = hasKlassenarbeiten && klassenarbeiten[0].maxPunkte && klassenarbeiten[0].maxPunkte[0];

    const aufgabenText = hasMaxPunkte ? " - Aufgaben: " + (klassenarbeiten[0].maxPunkte[0].length - 3) : "";
    const maximalpunkteText = hasMaxPunkte ? " - Maximalpunkte: " + klassenarbeiten[0].maxPunkte[0][klassenarbeiten[0].maxPunkte[0].length - 1].value : "";

    const message = "Klassenarbeiten: " + klassenarbeiten.length + aufgabenText + maximalpunkteText;

    // const handleReset = () => {
    //     const ret = {
    //         header: "Wollen Sie das Werkzeug wirklich zurücksetzen?",
    //         body: "Alle Ihre Daten gehen dabei verloren. Diese Aktion kann nicht rückgängig gemacht werden.",
    //         footer_cancel: "Abbrechen",
    //         footer_confirm: "Zurücksetzen",
    //         // method_confirm: null,
    //         visible: true,
    //     }
    //     // backCallerHandleReset(ret);
    // }

    function handleClick() {
        var wrapper = document.querySelector('.move-right');
        var toggleIconDiv = document.getElementById('toggle-icon-div');

        backCallerHandleToggleOffCanvas();

        if (!parentState.helper.offcanvas.show) {
            wrapper.classList.add('offcanvas-open');
            setTimeout(function () {
                toggleIconDiv.classList.remove('oc-close');
                toggleIconDiv.classList.add('oc-open');
            }, 50);
        } else {
            wrapper.classList.remove('offcanvas-open');
            setTimeout(function () {
                toggleIconDiv.classList.remove('oc-open');
                toggleIconDiv.classList.add('oc-close');
            }, 50);
        }
    }

    const renderTooltip = ({ message, className }) => (
        <Tooltip id="tooltip" className={`${className} no-print`}>
            {/* <Tooltip id="tooltipper" {...props}
            style={{
                backgroundColor: '#f0f0f0', // Light background
                color: '#333', // Dark text
                border: '1px solid #ccc', // Border
                padding: '10px' // Padding
            }}> */}
            {message}</Tooltip>
    );

    return (
        <>
            <nav className="navbar navbar-light bg-light fixed-top p-1 border-bottom">
                <div className="container-fluid pe-0">
                    <div className="flex-container">

                        <div id="toggle-icon-div" className="me-2 oc-open no-print">
                            <Button id="toggle-icon-button" className="navbar-toggler p-0 px-2" type="button"
                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
                                aria-controls="offcanvasNavbar"
                                onClick={handleClick}>
                                <span id="toggle-icon-button-span"
                                    className="fw-bold navbar-toggler-icon navbar-toggle-icon-black"></span>
                            </Button>
                        </div>

                        <div className="me-2">
                            <Link to="/auswertung">
                                <img id="headerImageLion" src={`${process.env.PUBLIC_URL}/bw.svg`} alt="Baden-Württemberg"
                                    title="Baden-Württemberg" />
                            </Link>
                        </div>

                        <div className="fw-bold nowrap-text flex-grow-1">
                            {strToolNameHeadline}
                        </div>

                        <div className="me-2">
                            <Button onClick={() => openNewTabWithChecklist()} // XXX
                                variant="outline-light" className="px-0">
                                <OverlayTrigger
                                    placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={renderTooltip({
                                        message: message,
                                        className: "custom-tooltipper"
                                    })}
                                >
                                    <i className="bi bi-info-circle"></i>
                                </OverlayTrigger>
                            </Button>
                        </div>

                        {/* <div className="me-2">
                            <Button onClick={() => alert("Hilfe")}
                                variant="outline-light" className="px-0">
                                <i className="bi bi-info-circle"></i>
                            </Button>
                        </div> */}

                        <div className="me-2">
                            <Button onClick={() => backCallerHandlePrint()}
                                variant="outline-light" className="px-0">
                                <OverlayTrigger placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={renderTooltip({
                                        message: "Aktuelle Ansicht drucken",
                                        className: "custom-tooltipper"
                                    })}
                                >
                                    <i className="bi bi-printer"></i>
                                </OverlayTrigger>
                            </Button>
                        </div>

                        <div className="me-2">
                            <Button onClick={() => backCallerGoModal('reset')}
                                variant="outline-light" className="px-0 me-0">
                                <OverlayTrigger placement="bottom-start"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={renderTooltip({
                                        message: "Werkzeug zurücksetzen",
                                        className: "custom-tooltipper"
                                    })}
                                >
                                    {/* <i className="bi bi-arrow-counterclockwise"></i> */}
                                    <i className="bi bi-x-octagon reset-icon" aria-label="Werkzeug zurücksetzen"></i>
                                </OverlayTrigger>
                            </Button>
                        </div>

                        {/* <div className="me-2">
                            <CSSToggler />
                        </div> */}

                    </div>
                </div>
            </nav >

        </>
    )
}

export default NavbarTop;